import React from 'react';
import { IconProps } from '.';

const SvgColoredExcel = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#185C37'
        d='M6 3a1.5 1.5 0 0 1 1.5-1.5H21A1.5 1.5 0 0 1 22.5 3v18a1.5 1.5 0 0 1-1.5 1.5H7.5A1.5 1.5 0 0 1 6 21V3Z'
      />
      <path fill='#21A366' d='M6 3a1.5 1.5 0 0 1 1.5-1.5h6.75v5.25H6V3Z' />
      <path fill='#33C481' d='M14.25 1.5H21A1.5 1.5 0 0 1 22.5 3v3.75h-8.25V1.5Z' />
      <path fill='#21A366' d='M14.25 6.75h8.25V12h-8.25V6.75Z' />
      <path fill='#107C41' d='M14.25 12h8.25v5.25h-8.25V12ZM6 6.75h8.25V12H6V6.75Z' />
      <path
        fill='#117B41'
        d='M1.5 8.25A1.5 1.5 0 0 1 3 6.75h7.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5v-7.5Z'
      />
      <path
        fill='#fff'
        d='m4.125 15 1.902-3.008L4.284 9h1.402l.95 1.913c.088.182.149.317.181.406h.012c.063-.145.129-.286.198-.422L8.043 9H9.33l-1.787 2.974L9.375 15H8.006l-1.098-2.1a1.778 1.778 0 0 1-.131-.28H6.76a1.34 1.34 0 0 1-.127.271L5.503 15H4.124Z'
      />
      <path fill='#134A2C' d='M12 12v3.75a1.5 1.5 0 0 1-1.5 1.5H6V18h4.875c1.036 0 1.875-.84 1.875-1.875V12H12Z' />
      <path fill='#0D6334' d='M12.75 9.375V12H12V8.25c0-.145-.02-.285-.059-.418.489.339.809.903.809 1.543Z' />
    </svg>
  );
};

export default SvgColoredExcel;
